// Shared select/option constants for consistent forms across the app.

export const US_STATES = [
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"], ["CA", "California"],
  ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"], ["DC", "District of Columbia"],
  ["FL", "Florida"], ["GA", "Georgia"], ["HI", "Hawaii"], ["ID", "Idaho"], ["IL", "Illinois"],
  ["IN", "Indiana"], ["IA", "Iowa"], ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"],
  ["ME", "Maine"], ["MD", "Maryland"], ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"],
  ["MS", "Mississippi"], ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"],
  ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"], ["NY", "New York"],
  ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"], ["OK", "Oklahoma"], ["OR", "Oregon"],
  ["PA", "Pennsylvania"], ["RI", "Rhode Island"], ["SC", "South Carolina"], ["SD", "South Dakota"],
  ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"], ["VT", "Vermont"], ["VA", "Virginia"],
  ["WA", "Washington"], ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"],
];

export const EQUIPMENT_TYPES = [
  "Dry Van", "Reefer", "Flatbed", "Hotshot", "Step Deck", "Conestoga",
  "Box Truck", "Straight Truck", "Power Only", "Lowboy", "Tanker", "Other",
];

export const PAY_TYPES = [
  { value: "owner_operator", label: "Owner-Operator" },
  { value: "per_mile", label: "Per Mile" },
  { value: "percentage", label: "Percentage" },
  { value: "salary", label: "Salary" },
];

export const SALARY_FREQUENCIES = ["Weekly", "Bi-Weekly", "Monthly", "Annual"];

export const ENDORSEMENTS = [
  { code: "H", label: "H — Hazmat" },
  { code: "N", label: "N — Tank Vehicle" },
  { code: "P", label: "P — Passenger" },
  { code: "S", label: "S — School Bus" },
  { code: "T", label: "T — Double/Triple Trailers" },
  { code: "X", label: "X — Hazmat + Tank" },
  { code: "TWIC", label: "TWIC Card" },
  { code: "TSA", label: "TSA Clearance" },
];

export const PAYMENT_METHODS = ["ACH", "Zelle", "Check", "Wire Transfer", "Other"];

export const INVOICE_PRODUCTS = ["Dispatch", "Trailer Renting", "Fleet Subscription", "Driver Recruitment", "Factoring Commission"];
export const FACTORING_PRODUCT = "Factoring Commission";
